import { createGlobalStyle } from 'styled-components'

export const TicketOverrides = createGlobalStyle`
  .modal-content {
    border: none;
    border-radius: 10px;
  }

  .error-message {
    color: var(--cui-form-invalid-color);
    font-size: 12px;
    top: 10px !important;
  }

  .card {
    border: none;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .custom-input-ticket-comp-values {
    border: 1px solid #d8e0e8;
    border-radius: 8px;
    background-color: #f8f9fd !important;
    min-height: 51px;
    padding: 1em;
    width: 100%;
  }

  .custom-input-driver-comp {
    position: relative;
    display: inline-block;
    color: rgb(129, 135, 147);
    padding: 13px 10px;
    border: 1px solid #d8e0e8;
    border-radius: 5px;
    height: 50px !important;
    background-color: #f8f9fd !important;
  }

  .custom-select-driver {
    display: flex;
    border: 1px solid #d8e0e8;
    border-radius: 4px;
    background-color: #f8f9fd !important;
    min-height: 51px;
    font-size: 14px;
    font-weight: 500 !important;
  }

  .react-datepicker__close-icon::after {
    background-color: transparent !important;
    position: absolute;
    right: 35px;
    top: 0.7em !important;
    box-sizing: border-box !important;
    font-size: large !important;
    color: black !important;
  }

  .custom-label-driver {
    display: flex !important;
    font-size: 11px !important;
    margin-bottom: 10px !important;
    padding: 0 !important;
    font-weight: 600 !important;
  }

  .custom-label-ticket-comp .row .col label {
    margin: auto !important;
    display: block !important;
    font-size: 12px !important;
    margin-bottom: 5px !important;
    margin-top: 30px !important;
    font-weight: 600 !important;
    color: #55555f !important;
  }

  .custom-label-ticket-comp .row .col select,
  .custom-label-ticket-comp .row .col input {
    font-size: 12px !important;
    height: 51px !important;
  }

  .custom-label-ticket-comp label {
    margin: auto !important;
    display: block !important;
    font-weight: 600 !important;
    color: #55555f !important;
    font-size: 13px !important;
  }

  .custom-label-vehicle-comp .row .col label {
    margin: auto !important;
    display: block !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #55555f !important;
  }

  .button-upload {
    background-color: #f8f9fd !important;
    border: 1px solid #d8e0e8 !important;
    padding: 15px 16px !important;
    border-radius: 8px !important;
    font-size: 12px !important;
    transform: translateX(-10%) !important;
    display: inline-block !important;
  }

  .copyPasteIcon {
    color: darkgray;

    &:hover {
      color: black !important;
    }
  }

  .button-upload-bill {
    background-color: #f8f9fd !important;
    border: 1px solid #d8e0e8 !important;
    padding: 15px 16px !important;
    border-radius: 8px !important;
    font-size: 12px !important;
    transform: translateX(-10%) !important;
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between;
  }

  .button-new-ticket {
    background-color: #f8f9fd !important;
    border: 1px solid #d8e0e8 !important;
    border-radius: 8px !important;
    position: inline-block !important;
    display: flex !important;
    margin-bottom: 30px !important;
    width: 70% !important;
    text-align: center;
    margin: auto;
  }
`
